export enum StockCheckType {
  SelectType = 0,
  DailyCount = 1,
  WeeklyCount = 2,
  MonthlyCount = 3,
  EndofMonthCount = 4
}

export const StockCheckTypeLabels: Record<StockCheckType, string> = {
  [StockCheckType.SelectType]: 'Select Type',
  [StockCheckType.DailyCount]: 'Daily Count',
  [StockCheckType.WeeklyCount]: 'Weekly Count',
  [StockCheckType.MonthlyCount]: 'Monthly Count',
  [StockCheckType.EndofMonthCount]: 'End of Month Count',
};